import React, { useState } from "react";

import Amini from "../../assets/amini.jpg";
import Turksuy from "../../assets/turksuy.jpg";
import Qaane from "../../assets/Qaane.jpg";
import Hussain from "../../assets/hussain.png";
import Nabizada from "../../assets/nabizada.jpg";
import Sadiqy from "../../assets/sadiqy.jpg";

// --- Icon Components ---
const TwitterIcon = () => (
  <svg
    className="w-5 h-5"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" />
  </svg>
);

const LinkedinIcon = () => (
  <svg
    className="w-5 h-5"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    <path
      fillRule="evenodd"
      d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
      clipRule="evenodd"
    />
  </svg>
);

const MailIcon = () => (
  <svg
    className="w-5 h-5"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    ></path>
  </svg>
);

// ---Members Data ---
const teamMembers = [
  {
    id: 1,
    name: "Mir Ahmad Nabizada",
    role: "Founder & CEO",
    image: Nabizada,
    bio: "Nabizada leads the vision with over 15 years of experience in tech strategy. He believes in building products that genuinely solve human problems.",
    skills: ["Leadership", "Strategy", "Product Design", "Team Lead"],
    email: "nabizada@example.com",
    linkedin: "",
    x: "",
  },
  {
    id: 2,
    name: "Farhad Sadiqi",
    role: "General Manager",
    image: Sadiqy,
    bio: "Sadeqi is oversees our architecture and ensures our platform is scalable and secure.",
    skills: [
      "Leadership",
      "Strategy",
      "Management",
      "Team Lead",
      "Performance Analysis",
      "Problem-Solving",
    ],
    email: "farhad@example.com",
    linkedin: "",
    x: "",
  },
  {
    id: 3,
    name: "Nasibullah Qaane",
    role: "HR Manager",
    image: Qaane,
    bio: "Experienced in administrative and HR management, focused on building efficient systems, supporting teams, and enabling tech-driven organizations to scale effectively.",
    skills: [
      "Operations",
      "Management",
      "Coordination",
      "Process Optimization",
      "Effective Communication",
    ],
    email: "qaane@example.com",
    linkedin: "",
    x: "",
  },
  {
    id: 4,
    name: "Fahim Turksoy",
    role: "Director of Digital Marketing",
    image: Turksuy,
    bio: "With a strong focus on driving growth through data-led strategy and innovation. Experienced in building high-performing digital campaigns that connect brands with customers and deliver measurable results.",
    skills: [
      "Monitoring",
      "Sales",
      "Markiting",
      "Outsourcing",
      "Business Development",
      "Team Lead",
    ],
    email: "fahim-turksoy@yarqinhub.com",
    linkedin: "https://af.linkedin.com/in/fahim-turksoy",
    x: "",
  },
  {
    id: 5,
    name: "Ebadullah Amini",
    role: "Developer",
    image: Amini,
    bio: "As a Developer, I specialize in designing and developing reliable digital solutions, with a strong focus on performance, quality, and innovation.",
    skills: [
      "Python",
      "Java Script",
      "SQL",
      "PHP",
      "React",
      "Flutter",
      "Dart",
      "Node JS",
    ],
    email: "amini@example.com",
    linkedin: "",
    x: "",
  },
  {
    id: 6,
    name: "Hussain Haidarzada",
    role: "Developer",
    image: Hussain,
    bio: "As a Developer, I create efficient and reliable digital solutions, driven by performance, quality, and innovation.",
    skills: [
      "Java",
      "Java Script",
      "SQL",
      "PHP",
      "React",
      "Flutter",
      "Python",
      "Node JS",
    ],
    email: "hussain@example.com",
    linkedin: "",
    x: "",
  },
];

const TeamCard = ({ member }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <article
      className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-1 flex flex-col h-full group"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="relative h-80 overflow-hidden bg-gray-200">
        <img
          src={member.image}
          alt={member.name}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        {/* Social Overlay */}
        <div
          className={`absolute inset-0 bg-slate-900/90 transition-opacity duration-300 flex items-center justify-center gap-4 ${
            isHovered ? "opacity-100" : "opacity-0"
          }`}
        >
          <a
            href="#"
            className="p-2 bg-white rounded-full text-slate-900 hover:bg-blue-50 transition transform hover:scale-110"
            aria-label="Twitter"
          >
            <TwitterIcon />
          </a>
          <a
            href={member.linkedin}
            className="p-2 bg-white rounded-full text-slate-900 hover:bg-blue-50 transition transform hover:scale-110"
            aria-label="LinkedIn"
          >
            <LinkedinIcon />
          </a>
          <a
            href={`mailto:${member.email}`}
            className="p-2 bg-white rounded-full text-slate-900 hover:bg-blue-50 transition transform hover:scale-110"
            aria-label="Email"
          >
            <MailIcon />
          </a>
        </div>
      </div>
      <div className="p-6 flex-1 flex flex-col">
        <div className="mb-4">
          <h3 className="text-xl font-bold text-slate-900">{member.name}</h3>
          <p className="text-blue-600 font-medium text-sm">{member.role}</p>
        </div>
        <p className="text-gray-500 text-sm mb-6 flex-1 leading-relaxed">
          {member.bio}
        </p>
        <div className="flex flex-wrap gap-2 mt-auto">
          {member.skills.map((skill, index) => (
            <span
              key={index}
              className="px-3 py-1 bg-gray-100 text-gray-600 text-xs font-semibold rounded-full"
            >
              {skill}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
};

const OurTeamSection = () => (
  <section id="team" className="py-24 bg-white">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          Our Leadership
        </h2>
        <p className="text-gray-500 max-w-2xl mx-auto">
          Get to know the people driving our mission forward. We combine deep
          technical expertise with creative flair.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {teamMembers.map((member) => (
          <TeamCard key={member.id} member={member} />
        ))}
      </div>
    </div>
  </section>
);

export default OurTeamSection;
